export default "__VITE_ASSET__DG_h0BsM__"